/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyListRequest {
    getFixupPrototypeFunction() { return PolicyListRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyListRequest>): PolicyListRequest {
        let obj = Object.assign(new PolicyListRequest(), model);
        PolicyListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyListRequest>): PolicyListRequest {
        if (!model) return null;
        return PolicyListRequest.newInstance(<PolicyListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyListRequest) {
        if (!obj) return;

        models.PolicyListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyListRequest): boolean {
        Object.setPrototypeOf(obj, PolicyListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the policy
     */
    name: string;

    /**
     * Display name of the policy
     */
    display_name: string;

    /**
     * Scope of the policy.
     */
    scope: string;

    policy_uris: Array<string>;

    services: Array<models.PolicyServiceName>;

    /**
     * Category of the policy.
     */
    category: string;

    /**
     * Status of the policy.
     */
    status: string;

    /**
     * Type of the policy.
     */
    policy_type: string;

    /**
     * Engine type of the policy.
     */
    engine_type: string;

    /**
     * Classification of the policy.
     */
    classification: models.PolicyClassification;

    /**
     * Sub-classification of the policy.
     */
    sub_classification: string;

    /**
     * Resource type of the policy.
     */
    resource_type: string;

    /**
     * Service resource of the policy.
     */
    service_resource: string;

    /**
     * When true, returns only policies that support remediation(s).
     */
    remediation_supported: boolean;

}
